"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var index_1 = require("../index");
var AccountsReceivableResource = /** @class */ (function (_super) {
    tslib_1.__extends(AccountsReceivableResource, _super);
    function AccountsReceivableResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AccountsReceivableResource.endpoint = '/ars';
    AccountsReceivableResource.MODEL_NAME = 'accountsreceivable';
    return AccountsReceivableResource;
}(index_1.BaseTransactionResource));
exports.default = AccountsReceivableResource;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/transactions/ar/index.js
// module id = 62t3
// module chunks = 0